
import { fetch } from '@/services/base'
import DivisionTransformer from '@/transformers/catalogs/division'

/**
 * Fetches a division list
 * @return {Promise} An http GET request
 */
const fetchDivisions = () =>
  fetch('divisions', {
    id: 'user',
    useTransformer: DivisionTransformer,
    urlGroup: 'catalogs'
  })

export default fetchDivisions
